var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Renderer } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';
var BgColorDirective = /** @class */ (function () {
    function BgColorDirective(el, renderer, comProv) {
        this.el = el;
        this.renderer = renderer;
        this.comProv = comProv;
        this.setColor();
    }
    BgColorDirective.prototype.setColor = function () {
        var bg_color = '#ffffff';
        var image;
        if (localStorage.getItem('base_data') && localStorage.getItem('base_data') != '') {
            var base_data = JSON.parse(localStorage.getItem('base_data'));
            if (base_data['background_color']) {
                bg_color = base_data['background_color'];
            }
            if (base_data['background_image']) {
                image = base_data['background_image'];
            }
        }
        if (image) {
            image = this.comProv.getThumbnailUrl(image, 1080);
            this.renderer.setElementStyle(this.el.nativeElement, 'backgroundImage', 'url(' + image + ')');
            this.renderer.setElementStyle(this.el.nativeElement, 'backgroundSize', '100% auto');
            //this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', 'transparent');
        }
        this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', bg_color);
    };
    BgColorDirective = __decorate([
        Directive({
            selector: '[bg-color]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Renderer,
            CommonProvider])
    ], BgColorDirective);
    return BgColorDirective;
}());
export { BgColorDirective };
//# sourceMappingURL=bg-color.js.map


// WEBPACK FOOTER //
// ./src/directives/bg-color/bg-color.ts.pre-build-optimizer.js